import React from "react";
var __jsx = React.createElement;
import { DateField } from "@/components/date-field";
/** SDS date + time field exchanging a 'YYYY-MM-DDTHH:mm' string; wraps the generic DateField. */
export function FormDateTime(_ref) {
  var label = _ref.label,
    withAsterisk = _ref.withAsterisk,
    required = _ref.required,
    value = _ref.value,
    _onChange = _ref.onChange,
    testId = _ref.testId,
    showNow = _ref.showNow,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    error = _ref.error,
    maxDate = _ref.maxDate,
    minDate = _ref.minDate,
    placeholder = _ref.placeholder,
    _ref$displayFormat = _ref.displayFormat,
    displayFormat = _ref$displayFormat === void 0 ? "MM/dd/yyyy" : _ref$displayFormat,
    highlightToday = _ref.highlightToday;
  return /*#__PURE__*/React.createElement(DateField, {
    type: "datetime",
    variant: "field",
    value: value,
    onChange: function onChange(next) {
      return _onChange(next);
    },
    testId: testId !== null && testId !== void 0 ? testId : "",
    label: label,
    placeholder: placeholder,
    displayFormat: displayFormat,
    withAsterisk: withAsterisk,
    required: required,
    showNow: showNow,
    disabled: disabled,
    error: error,
    minDate: minDate,
    maxDate: maxDate,
    highlightToday: highlightToday
  });
}